import React from "react";

const RandomIcon = () => {
  return (
    <svg width="17" height="16" role="img" aria-label="Random Icon" viewBox="0 0 17 16" fill="none">
      <path fill="#fff" d="M1.443 4.705h3.3c.694 0 1.313.368 1.745.942a7.631 7.631 0 0 1 1.123-1.564c-.757-.774-1.76-1.26-2.868-1.26h-3.3a.942.942 0 1 0 0 1.882Z"/>
      <path fill="#fff" d="M8.22 7.634c.49-1.56 2.005-2.928 3.244-2.928h1.633l-1.149 1.217a.98.98 0 0 0 0 1.33c.173.184.4.276.628.276a.862.862 0 0 0 .629-.275l3.295-3.49L13.205.277a.854.854 0 0 0-1.257 0 .98.98 0 0 0 0 1.33l1.15 1.218h-1.634c-2.022 0-4.188 1.85-4.931 4.215l-.42 1.328c-.57 1.813-1.841 2.927-2.502 2.927H1.39c-.492 0-.889.422-.889.941 0 .52.397.941.889.941H3.61c1.633 0 3.434-1.811 4.19-4.215l.419-1.327Z"/>
      <path fill="#fff" d="M11.924 8.747a.976.976 0 0 0 0 1.33l1.155 1.217h-2.09c-1.132 0-2.081-.838-2.404-1.984a8.982 8.982 0 0 1-.974 2.057c.792 1.093 2.004 1.81 3.379 1.81h2.09l-1.156 1.216a.976.976 0 0 0 0 1.331.869.869 0 0 0 .631.276.868.868 0 0 0 .632-.276l3.313-3.489-3.313-3.488a.861.861 0 0 0-1.263 0Z"/>
    </svg>
  );
};

export default RandomIcon;
